import { createContext } from 'react';

interface TableContextProps {
  data: any[];
  setData: (newData: any[]) => void;
  stickyClasses?: {
    right: string;
    header: string;
    headerRight: string;
  };
}

export const TableContext = createContext<TableContextProps>({
  data: [],
  setData: (newData) => {
    // pass
  },
  stickyClasses: {
    right: '',
    header: '',
    headerRight: '',
  },
});
